import { useGetOrganization } from '@sib/api';
import { useUserSetupStore } from '@sib/auth';
import { useTranslation } from '@sib/i18n';
import { Button, ButtonProps, Tooltip } from '@sib/ui';
import { useDialog } from '../../hooks';
import { ShareDialog } from './ShareDialog';

interface ShareButtonProps extends ButtonProps {
  className?: string;
}

export const ShareButton = ({ onClick, ...props }: ShareButtonProps) => {
  const { t } = useTranslation();
  const { handleOpen, handleClose, isOpen } = useDialog();
  const organizationId = useUserSetupStore(state => state.organization.id);
  const { data: organization } = useGetOrganization(organizationId);

  const organizationDomains = organization?.domains ?? [];
  const isShareUnavailable = organizationDomains.length === 0;

  return (
    <>
      <ShareDialog onClose={handleClose} open={isOpen} />
      <Tooltip
        content={
          isShareUnavailable
            ? t('components.shareDialog.shareUnavailable')
            : null
        }
      >
        <span>
          <Button
            onClick={e => {
              handleOpen();
              onClick?.(e);
            }}
            disabled={isShareUnavailable}
            {...props}
          >
            {t('share')}
          </Button>
        </span>
      </Tooltip>
    </>
  );
};
